const ids = [
    'ov-onskeskyen-generated-wish-button',
    'gowishRoundedButton',
    'gowishBlueButton',
    'gowishWhiteButton',
    'gowishDynamicButton'
];

const GOWISH_SCRIPT_ID = 'gowish-iframescript'; // script should be imported with this id
const GOWISH_REGION_ATTR_NAME = 'data-region'; // region attribute name - optional
const GOWISH_PRODUCT_URL_ATTR_NAME = 'data-producturl'; // product url attribute name - optional
const GOWISH_ENV_ATTR_NAME = 'data-env'; // dev, staging, prod
const GOWISH_USE_BTN_REGION = 'data-use-btn'; // use btn attribute name - optional
const GOWISH_IFRAME_ID = 'gowish-iframe'; // id iframe created by this script
const GOWISH_DIALOG_ID = 'gowish-iframe-dialog'; // id of dialog created by this script
const IFRAME_STYLE_EVENTS = ['setIframeHeight', 'setIframeWidth'];

let isLoggingInWithSocial = false;

// Adds click eventlistener for opening the iframe
document.addEventListener('click', function (e) {
    if (e.target && e.target instanceof HTMLButtonElement) {
        const baseId = e.target.id.replace(/\d+$/, ''); // Remove numeric suffix
        if (ids.includes(baseId)) {
            const script = document.getElementById(GOWISH_SCRIPT_ID);
            const btn = document.getElementById(e.target.id);
            let region = 'denmark';
            let targetUrl = undefined;
            let metadataSource = undefined;
            if (script) {
                region = script.getAttribute(GOWISH_REGION_ATTR_NAME) || 'denmark'; // fallback region is Denmark
            }
            if (btn && script) {
                if (script.getAttribute(GOWISH_USE_BTN_REGION)) {
                    region = btn.getAttribute(GOWISH_REGION_ATTR_NAME) || 'denmark'; // fallback region is Denmark
                }
                // Use product url as target url if defined
                const productUrl = btn.getAttribute(GOWISH_PRODUCT_URL_ATTR_NAME);
                if (productUrl && URL.canParse(productUrl)) {
                    targetUrl = productUrl;
                }
            }
            createIframe(region, targetUrl, metadataSource);
        }
    }
});

// Adds message eventlistener for onClose
window.addEventListener(
    'message',
    event => {
        if (event.data === 'onClose') {
            const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
            if (dialogElement) {
                document.body.removeChild(dialogElement);
            }
        }
    },
    false
);

function getUrlBase() {
    const script = document.getElementById(GOWISH_SCRIPT_ID);
    const env = script?.getAttribute(GOWISH_ENV_ATTR_NAME) ?? 'prod';

    switch (env) {
        case 'local':
            return {
                ROOT_DK: 'http://localhost:3000',
                ROOT_NO: 'http://localhost:3000',
                ROOT_GLOBAL: 'http://localhost:3000'
            };
        case 'dev':
            return {
                ROOT_DK: 'https://dev.onskeskyen.dk',
                ROOT_NO: 'https://dev.onskeskyen.no',
                ROOT_GLOBAL: 'https://dev.gowish.com'
            };
        case 'staging':
            return {
                ROOT_DK: 'https://staging.onskeskyen.dk',
                ROOT_NO: 'https://staging.onskeskyen.no',
                ROOT_GLOBAL: 'https://staging.gowish.com'
            };
        case 'prod':
        default:
            return {
                ROOT_DK: 'https://onskeskyen.dk',
                ROOT_NO: 'https://onskeskyen.no',
                ROOT_GLOBAL: 'https://gowish.com'
            };
    }
}

// Returns iframe src url for a given region + encoded crawlertarget
function getIframeSrc(region, encodedPath, metadataSource) {
    const {
        ROOT_GLOBAL,
        ROOT_NO,
        ROOT_DK
    } = getUrlBase();
    let path = ""
    if (metadataSource) {
        path = `/quick-add?source=button&crawlerTarget=${encodedPath}&metadataSource=${metadataSource}`;
    } else {
        path = `/quick-add?source=button&crawlerTarget=${encodedPath}`;
    }

    switch (region) {
        case 'global':
            return ROOT_GLOBAL + path;
        case 'norway':
            return ROOT_NO + path;
        default:
            return ROOT_DK + path; // Defaults to Denmark
    }
}

// Get scheme based on region
// region can be: "global", "denmark" or "norway"
const getScheme = region => {
    if (region === 'global') {
        return 'gowish://';
    }

    return 'onskeskyen://';
};

// Creates the iframe
function createIframe(region, targetUrl, metadataSource) {
    try {
        // Construct encoded path for product
        const params = new URLSearchParams(window.location.search);
        const uri =
            targetUrl || params.get('crawlerTarget') || window.location.href;
        const encoded = encodeURIComponent(uri);

        // Check if this is a mobile device
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (isMobile) {
            const scheme = getScheme(region);
            let url = '';

            if (metadataSource) {
                url = `${scheme}quick-add?source=button&crawlerTarget=${encoded}&metadataSource=${metadataSource}`;
            } else {
                url = `${scheme}quick-add?source=button&crawlerTarget=${encoded}`;
            }
            window.location.href = url;

            window.addEventListener('message', event => {
                const hasType =
                    typeof event.data === 'object' &&
                    Boolean(event.data) &&
                    'type' in event.data;
                const type =
                    hasType && typeof event.data.type === 'string' ?
                        event.data.type :
                        undefined;
                if (type === 'gowish_iframe_open_popup') {
                    const authUrls = [
                        'https://auth.gowish.com/',
                        'https://auth.dev.gowish.com/',
                        'https://auth.staging.gowish.com/'
                    ];

                    // Ensure url is auth url
                    if (!authUrls.some(authUrl => event?.data?.url.startsWith(authUrl))) {
                        return;
                    }

                    // Prevent closing iframe when returning to page
                    isLoggingInWithSocial = true;
                }
            });

            // Close iframe if return to page
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    if (isLoggingInWithSocial) {
                        isLoggingInWithSocial = false;
                    } else {
                        const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
                        if (dialogElement) {
                            document.body.removeChild(dialogElement);
                        }
                    }
                }
            });
        }

        const iframe = document.getElementById(GOWISH_IFRAME_ID);
        if (iframe) {
            // Close iframe if already opened
            const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
            if (dialogElement) {
                document.body.removeChild(dialogElement);
            }
        } else {
            // Get iframe src
            const iframeSrc = getIframeSrc(region, encoded, metadataSource);
            // Create a modal
            const modal = document.createElement('dialog');
            modal.setAttribute('class', 'gowish-dialog');
            modal.setAttribute('id', GOWISH_DIALOG_ID);

            // styling the modal
            const style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            const baseWidth = window.innerWidth;
            const css = `
            .gowish-dialog {          
              background-color: rgba(0, 153, 187, 0.45);
              border-width: 0;
              min-width: 100%;
              min-height: 100%;
              width: 100%;
              height: 100%;
              text-align: center;
            }
  
            .gowish-iframe {
              min-height: 400px;
              max-width: 780px;
              min-width: 370px;
              border: none;
              border-radius: 30px;
              bottom: 30px;
              top: 20px;
            }
  
              /* Mobile styles */
              @media screen and (max-width: 767px) {
                .gowish-iframe {
                  border-radius: 20px 20px 0 0;
                  max-width: 780px;
                  min-width: 300px;
                }
              }
  
              @media screen and (max-width: 400px) {
                .gowish-iframe {
                  width: 100%;
                  max-width: 400px;
                  top: auto;
                  border-radius: 20px 20px 0 0;
                }
              }
  
              @media screen and (min-width: 768px) {
                .gowish-dialog {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }
            `;

            style.innerHTML = css;
            document.head.appendChild(style);

            modal.addEventListener('click', () => {
                const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
                if (dialogElement) {
                    document.body.removeChild(dialogElement);
                }
            });

            // Add iframe as a child to the modal
            modal.innerHTML = `
        <div id="modal-container" onclick="(e)=>{e.stopPropagation();e.preventDefault();}" class="gowish-modal-container" >
          <iframe
            id="${GOWISH_IFRAME_ID}"
            src="${iframeSrc}" 
            class="gowish-iframe"
          ></iframe>
        </div>
      `;

            // Append modal to the body
            document.body.appendChild(modal);

            // Adds message eventlistener for onClose
            window.addEventListener(
                'message',
                event => {
                    if (IFRAME_STYLE_EVENTS.includes(event.data?.type)) {
                        const iframe = document.getElementById(GOWISH_IFRAME_ID);
                        if (iframe && event.data.payload) {
                            const {
                                height,
                                width
                            } = event.data.payload;

                            if (height) {
                                iframe.style.height = height;
                            }
                            if (width) {
                                iframe.style.width = width;
                            }
                        }
                    }
                },
                false
            );

            const iframeItem = document.getElementById(GOWISH_IFRAME_ID);
            iframeItem.onload = function () {
                const doc = iframeItem.contentWindow.document,
                    head = doc.querySelector('head'),
                    style = doc.createElement('style');

                style.setAttribute('type', 'text/css');
                style.innerHTML = 'body { background: transparent!important; }';

                head.appendChild(style);
            };

            // Show the modal
            const dialogElement = document.getElementById(GOWISH_DIALOG_ID);
            if (dialogElement instanceof HTMLDialogElement) {
                dialogElement.showModal();
            }
        }
    } catch (err) {
        console.error(err);
    }
}